// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1u6mN","clinicsSelect":"styles_clinicsSelect__2B4ys"};